import { render } from "./ButtonMobile.vue?vue&type=template&id=5d03c550&scoped=true"
import script from "./ButtonMobile.vue?vue&type=script&lang=js"
export * from "./ButtonMobile.vue?vue&type=script&lang=js"

import "./ButtonMobile.vue?vue&type=style&index=0&id=5d03c550&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d03c550"]])

export default __exports__